import React, { useEffect, useState } from 'react';
import { verifyGoogleAuth } from "../../services/login-api.js";
import { Spin } from 'antd';
import GoogleSignErrorModal from "../modal/errorMessageGoogleSign-modal.js";
import { trackEvent } from '../../analytics/analytics_login.js';

const GoogleSignRedirect = () => {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loginDomain, setLoginDomain] = useState();
  const [accessToken, setAccessToken] = useState();

  const handleOpenModal = () => {
    setShowModal(true);
  };
  useEffect(() => {
    const fetchUserInfo = async () => {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const accessToken = hashParams.get('access_token');
      setAccessToken(accessToken);
      const stateParam = hashParams.get('state');

      if (!accessToken || !stateParam) {
        console.error('Access token or state parameter not found');
        setLoading(false);
        return;
      }
        const stateObj = JSON.parse(decodeURIComponent(stateParam));
        const companyIdFromState = stateObj.companyId;
        const curentUrlFromState = stateObj.current_url;
        // const dashboardUrlFromState = stateObj.dashboard_url;
        const response = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            "Authorization": `Bearer ${accessToken}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user information');
        }
        const userInfo = await response.json();
        if (userInfo.email_verified === true) {
          const loginObj = {
            "companyId": companyIdFromState,
            "eMail": userInfo.email
          };
          await loginUserHandler(loginObj, curentUrlFromState);
        } else {
          console.error('email is not verified')
          setLoading(false);
          window.location.href=curentUrlFromState;
        }
    };


    const loginUserHandler = async (loginObj, domainUrl) => {
      try {
        setLoginDomain(domainUrl);
        const response = await verifyGoogleAuth(loginObj);

        if (response.status === 200 && response.data && response.data.access_token) {

          let url = new URL(domainUrl);
            if (url.searchParams.has('logout') && url.searchParams.get('logout') === 'true') {
                url.searchParams.delete('logout');
            }
            let redirectDomain = `${url.origin}${url.pathname}?token=${response.data.access_token}`;
            window.location.href = redirectDomain;
        }

      } catch (error) {
        console.error(error);
        setLoading(false);
        if (error.response) {
          const errorMessage = error.response.data.message;
          console.error(errorMessage);
          trackEvent("Sign_in_with_google_account_not_found_in_platform",{message: errorMessage});
          handleOpenModal();
        }
      }
    };

    fetchUserInfo();
  }, []);

  return (
    <div>
      {/* Your main component content */}
      {loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>}

      {showModal && (
        <GoogleSignErrorModal
          title="User Not Found"
          url={loginDomain}
          content="The Gmail account you tried to log in with doesn't have an account on our platform. Please try logging in again with a valid account."
          accessToken={accessToken}
        />
      )}
    </div>
  );
};

export default GoogleSignRedirect;
